import { Formik } from "formik";
import { shallowEqual } from "react-redux";

import { useEditProfileMutation } from "@sso/apis/account";
import { CheckDirtyForm } from "@sso/components/Formik/ChackDirtyForm";
import { SubmitLoadingButton } from "@sso/components/SubmitLoadingButton";
import { UserFormFields } from "@sso/components/UserFormFields";
import { userFormSchemaValidation } from "@sso/components/UserFormFields/schema";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectCurrentUser } from "@sso/store/slices/auth";
import { User, UserForm } from "@sso/types";
import { CustomForm } from "@sso/ui/CustomForm";
import { Flex, GridItem } from "@sso/ui/FlexBox";

export const EditProfile = () => {
  const user = useAppSelector(selectCurrentUser) as User;

  const [editProfile, { isLoading }] = useEditProfileMutation();

  const { userId, firstname, lastname, username, email, mobile } = user;

  const profileValues = { userId, firstname, lastname, username, email, mobile: mobile || "" };

  const handleSubmit = (values: Partial<UserForm>) => {
    if (shallowEqual(profileValues, values)) {
      return;
    }
    editProfile(values);
  };

  if (!user) {
    return null;
  }
  return (
    <Formik initialValues={profileValues} validationSchema={userFormSchemaValidation} onSubmit={handleSubmit}>
      <CustomForm position="relative">
        <Flex wrap="wrap" align="baseline" padding="2rem 0 1rem 0" maxWidth="700px">
          <UserFormFields />
          <GridItem xs={12} sm={6} width="100%">
            <SubmitLoadingButton loading={isLoading} buttonTitle="Update" />
          </GridItem>
        </Flex>
        <CheckDirtyForm initialValues={profileValues} isDataLoading={false} />
      </CustomForm>
    </Formik>
  );
};
